

















import { Component, Vue } from "vue-property-decorator";
import DropOffSlotSelection from "@/components/drop-off/DropOffSlotSelection.vue";
import DropOffWorkbench from "@/components/drop-off/DropOffWorkbench.vue";
import { Drive } from "@/model/Drive";
import { Slot } from "@/model/collection/Slot";
import {Support} from "@/model/support/Support";

@Component({
  components: { DropOffSlotSelection, DropOffWorkbench }
})
export default class DropOffBody extends Vue {

  selectedDrive: Drive = null;
  selectedSlot: Slot = null;
  supportsToDropOff: Support[] = [];

  onSlotSelected(event: { drive: Drive, slot: Slot, supports: Support[] }): void {
    this.selectedDrive = event.drive;
    this.selectedSlot = event.slot;
    this.supportsToDropOff = event.supports;
  }

  unselectSlot(): void {
    this.selectedDrive = null;
    this.selectedSlot = null;
  }

  onSupportsUpdated(updatedList: Support[]) {
    this.supportsToDropOff = updatedList;
  }

  get workbenchId(): string {
    if (this.selectedDrive == null || this.selectedSlot == null) {
      return '';
    }

    return this.selectedDrive.driveId + "_" + this.selectedSlot.dueDate.getTime();
  }
}
